import React, { useEffect, useState } from "react";
import "./VirasatV2ContactPage.scss"
import VirasatV2InputComponents from "../../components/VirasatV2InputComponents/VirasatV2InputComponents";
import PhoneInputComponent from "../../components/VirasatV2InputComponents/PhoneInputComponent";
import VirsatTextArea from "../../components/VirasatV2InputComponents/VirsatV2TextArea";
import Button from "../../components/Button/Button";
import { useSelector } from "react-redux";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { isValidPhoneNumber } from 'react-phone-number-input';
import { sortByOrderAscending } from "../../helper/helper";
import { useHistory } from "react-router";
const VirasatV2ContactPage = () => {
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: "",
        phoneNumber: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.company)
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "contact")

    const Components = page?.Components || []
    const history = useHistory()

    useEffect(() => {
        window.scrollTo(0, 0);
        if (Components.length === 0) {
            history.push("/")
        }
    }, []);

    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            fullName: "",
            email: "",
            message: "",
            phoneNumber: ""
        }
        const trimmedName = fullName.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.fullName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.fullName = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        } else if (!isValidPhoneNumber(trimmedPhone)) {
            newErrors.phoneNumber = "Please enter a valid phone number";
            valid = false;
        }
        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatContactPage-hero-header":
                return <div className="VirasatV2ContactPage-hero-header-cont">
                    <div className="VirasatV2ContactPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatV2ContactPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="VirasatV2ContactPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${headerComponents?.Props?.bgSrc})`
            }}>
                <div className="VirasatV2ContactPage-hero-container">
                    <div className="VirasatV2ContactPage-hero-container-wrapper">
                        {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                            return (<div key={key}>
                                {getHeaderComponents(component)}
                            </div>)
                        })}
                    </div>
                </div>
            </div>
        )
    }
    const formComponent = () => {
        return (
            <div className="VirasatV2ContactPage-wrapper-container-left-form">
                <VirasatV2InputComponents
                    label={"Name"}
                    required
                    placeholder={"Enter your name"}
                    value={fullName}
                    onChange={(e) => {
                        setFullName(e.target.value)
                        handleChange("fullName")
                    }}
                    error={errors.fullName !== ""}
                    errorText={errors.fullName}
                />
                <VirasatV2InputComponents
                    label={"Email"}
                    placeholder={"Enter your email"}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        handleChange("email")

                    }}
                    value={email}
                    required
                    error={errors.email !== ""}
                    errorText={errors.email} />
                <PhoneInputComponent
                    label={"Phone Number"}
                    placeholder={"Enter your phone number"}
                    onChange={(e) => {
                        if (e === undefined) {
                            setPhoneNumber("")
                        } else {
                            setPhoneNumber(e)
                        }
                        handleChange("phoneNumber")

                    }}
                    value={phoneNumber}
                    required
                    error={errors.phoneNumber !== ""}
                    errorText={errors.phoneNumber} />
                <VirsatTextArea
                    label={"Message"}
                    placeholder={"Enter your message"}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        handleChange("message")

                    }}
                    value={message}
                    required
                    error={errors.message !== ""}
                    errorText={errors.message} />
                {showSuccess && < div className="succes-alert">
                    ✔ Thanks for subscribing! We can’t wait to open our doors to you..
                </div>}
                <div className="VirasatV2ContactPage-wrapper-container-left-form-btn">
                    <Button
                        text={"Send"}
                        onClick={handleContact}
                        isloading={loading} />
                </div>
            </div>
        )
    }
    const getleftContComponents = (component) => {
        switch (component.ID) {
            case "VirasatContactPage-container-left-title":
                return <div className="VirasatV2ContactPage-wrapper-container-left-title">{component?.Props?.header}
                    <div className="VirasatV2ContactPage-wrapper-container-left-title-hl">{component?.Props?.headerHighlight}</div>
                </div>
            case "VirasatContactPage-container-left-subheader":
                return <div className="VirasatV2ContactPage-wrapper-container-left-subheader">{component?.Props?.text}</div>
            case "VirasatContactPage-container-left-form":
                return formComponent(component?.Components)

            default:
                return <div />
        }

    }
    const leftContContainer = (leftcontainerComponents) => {
        return (
            <div className="VirasatV2ContactPage-wrapper-container-left">
                {sortByOrderAscending(leftcontainerComponents).map((component, key) => {
                    return (
                        getleftContComponents(component)
                    )
                })}



            </div>
        )
    }
    const getContainerComponents = (component) => {
        switch (component.ID) {
            case "VirasatContactPage-container-left":
                return leftContContainer(component?.Components)
            case "VirasatContactPage-container-right":
                return <div className="VirasatV2ContactPage-wrapper-container-right"
                    style={{ backgroundImage: `url(${component?.Props?.src})` }} />
            default:
                return <div />
        }

    }
    const containerComponent = (containerComponents) => {
        return (
            <div className="VirasatV2ContactPage-wrapper">
                <div className="VirasatV2ContactPage-wrapper-container">
                    {sortByOrderAscending(containerComponents).map((component, key) => {
                        return (
                            getContainerComponents(component)
                        )
                    })}
                </div >
            </div>

        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatContactPage-hero":
                return headerComponent(component)
            case "VirasatContactPage-container":
                return containerComponent(component?.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2ContactPage" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (getComponents(component))
            })}
        </div >
    )
}
export default VirasatV2ContactPage      